import axios from "axios";

const API_BASE = "/wp-json/checkout/v1/primer";

const primerAxios = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

primerAxios.interceptors.request.use((config) => {
  const nonce = window.wpApiSettings?.nonce;
  if (nonce) {
    config.headers["X-WP-Nonce"] = nonce;
  }

  return config;
});

export const primerPaymentService = {
  async createSession(orderData) {
    const response = await primerAxios.post(`${API_BASE}/session`, orderData);

    if (response.data.result !== "SUCCESS") {
      throw new Error("Failed to create Primer session");
    }

    return {
      clientToken: response.data.clientToken,
      orderId: response.data.orderId,
      expiresAt: response.data.expiresAt,
    };
  },

  async processPaymentWithToken(
    paymentMethodToken,
    orderData,
    products,
    orderId,
  ) {
    const response = await primerAxios.post(`${API_BASE}/order`, {
      paymentMethodToken,
      data: orderData,
      products,
      orderId,
    });

    return response.data;
  },

  async processPayment(cardData, orderData, products, clientToken) {
    const response = await primerAxios.post(`${API_BASE}/tokenize-and-pay`, {
      cardData,
      data: orderData,
      products,
      clientToken,
    });

    return response.data;
  },

  async resumePayment(paymentId, resumeToken, orderData, products) {
    const response = await primerAxios.post(`${API_BASE}/resume`, {
      paymentId,
      resumeToken,
      data: orderData,
      products,
    });

    return response.data;
  },

  async processUpsell(paymentMethodToken, originalOrderId, products) {
    const response = await primerAxios.post(`${API_BASE}/upsell`, {
      paymentMethodToken,
      originalOrderId,
      products,
    });

    return response.data;
  },

  async tokenizeAndPay(cardData, orderData, products, clientToken) {
    const response = await primerAxios.post(`${API_BASE}/tokenize-and-pay`, {
      cardData,
      data: orderData,
      products,
      clientToken,
    });

    return response.data;
  },
};

export default primerPaymentService;
